import { Injectable } from '@angular/core';
import { InAppBrowser } from '@awesome-cordova-plugins/in-app-browser/ngx';
import { Capacitor } from '@capacitor/core';
import { Platform } from '@ionic/angular';

@Injectable()
export class BrowserHelper {

    constructor(
        private inAppBrowser: InAppBrowser,
        private platform: Platform) {
    }

    openUrl(path, target = '_blank', options = 'enableViewportScale=yes,location=no') {
        // don't open the url if no url to open
        if (path == null) {
            return;
        }
        // Add http:// if the url is missing it
        if (!path.toLowerCase().startsWith('http')) {
            path = 'https://' + path;
        }

        console.log('=== Opening link from browser-helper.openUrl: ', path);

        if (Capacitor.isNativePlatform()) {
            // Social sites redirect to custom schemes (e.g. fb://) which InAppBrowser cannot handle
            if (target === '_blank' && this.shouldOpenInSystemBrowser(path)) {
                target = '_system';
            }
            // If the file isn't local, then use the inapp browser
            return this.inAppBrowser.create(path, target, options);
        } else {
            console.log('   open with: window.open(' + path + ', ' + target + ');');
            return window.open(path, target);
        }
    }

    // Just for stripe connect, code copied from raffles, breaks with above openUrl function
    openUrlNonCapacitor(path, target = '_blank', options = 'enableViewportScale=yes,location=no') {
        // don't open the url if no url to open
        if (path == null) {
            return;
        }

        // Add http:// if the url is missing it
        if (!path.toLowerCase().startsWith('http')) {
            path = 'https://' + path;
        }

        console.log('=== Opening link from browser-helper.openUrl: ', path);
        return window.open(path, target);
    }

    openUrlInSystem(path, target = '_system') {
        // don't open the url if no url to open
        if (path == null) {
            return;
        }

        if (!path.toLowerCase().startsWith('http')) {
            path = 'https://' + path;
        }

        console.log('=== Opening link in system: ', path);
        if (Capacitor.isNativePlatform()) {
            return this.inAppBrowser.create(path, '_system');
        }
        return window.open(path, target);
    }

    isSafari() {
        const ua = navigator.userAgent.toLowerCase();
        return ua.indexOf('safari') !== -1 && ua.indexOf('chrome') === -1;
    }

    static staticOpenUrl(path, target = '_blank', options = 'enableViewportScale=yes,location=no') {
        // Add http:// if the url is missing it
        if (!path.toLowerCase().startsWith('http')) {
            path = 'https://' + path;
        }

        console.log('=== Opening link from static browser-helper.openUrl: ', path);
        return window.open(path, target);
    }

    private shouldOpenInSystemBrowser(path: string): boolean {
        const socialHosts = [
            'facebook.com', 'fb.com', 'fb.me',
            'instagram.com', 'twitter.com', 'x.com', 'linkedin.com', 'tiktok.com'
        ];
        try {
            const host = new URL(path).hostname.toLowerCase().replace(/^www\./, '');
            return socialHosts.some(s => host === s || host.endsWith('.' + s));
        } catch {
            const lowerPath = path.toLowerCase();
            return socialHosts.some(s => lowerPath.includes(s));
        }
    }
}
